export const IDENTT_MANUAL = 'identt-manual';

export const SIZE_15MB = 15 * 1024 * 1024;

export const ALLOWED_EXTENSIONS = ['jpeg', 'jpg', 'png', 'tiff', 'pdf'];
